import { DefaultService } from '@/services/DefaultService';

export default class GerenciarUsuariosService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http.get(encodeURI(`${this._env}/config/gerenciarusuarios.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findById(id) {
        return this._http.get(`${this._env}/config/gerenciarusuarios/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save(form) {
        return this._http.post(`${this._env}/config/gerenciarusuarios`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    updateLocation(form) {
        return this._http.post(`${this._env}/config/gerenciarusuarioslatlong`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    ativar(user) {
        return this._http.post(`${this._env}/config/gerenciarusuarios/enable`, user, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    desativar(user) {
        return this._http.post(`${this._env}/config/gerenciarusuarios/disable`, user, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    validateLogin(login) {
        return this._http.post(`${this._env}/config/gerenciarusuarios/validate-login`, login, this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
            });
    }

    getParamsUsuario(page, limit, id, situacao, ...params) {
        return this._http.get(`${this._env}/config/parametrizacoes/${id}.json?page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/config/usuario/getcombo.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    qtdUsuariosAtivos() {
        return this._http.get(`${this._env}/config/gerenciarusuarios/qtd-usuarios-ativos.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

}